import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import {
  ReactiveFormsModule,
  FormControl,
  FormsModule,
  FormArray,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatChipsModule } from '@angular/material/chips';
import { NgToastService } from 'ng-angular-popup';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { FormGroup, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RfqSectionDialogsComponent } from '@/app/components/projects/project-requests/requested-tendering/requested-rfq/rfq-section-dialogs/rfq-section-dialogs.component';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { RichTextEditorComponent } from '@/app/components/shared/rich-textEditor/rich-textEditor.component';
import { MatRadioModule } from '@angular/material/radio';
import { environment } from '@/app/environments/environment';
import { GetFileIconUtilityService } from '@/app/services/utility/get-file-icon-utility.service';
import { RequestForQuotationService } from '@/app/services/tendering-services/rfq/rfq.service';
@Component({
  standalone: true,
  providers: [provideNativeDateAdapter()],
  imports: [
    MatChipsModule,
    MatButtonModule,
    MatSelectModule,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatDatepickerModule,
    RichTextEditorComponent,
    MatRadioModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-rfq-technical-submission',
  templateUrl: './rfq-technical-submission.component.html',
  styleUrls: ['./rfq-technical-submission.component.css'],
})
export class RfqTechnicalSubmissionComponent implements OnInit {
  base_path = environment.storageUrl;
  resetRichTextEditor = false;
  isEdit = false;
  eoiTitle: FormControl<any>;
  submittedGuidlines: any;
  ittId: number;
  oldCvOfKeyPersonalFiles = [];
  deletedCvOfKeyPersonalFiles = [];
  constructor(
    private RfqSectionDialogsComponent: RfqSectionDialogsComponent,
    private toast: NgToastService,
    private requestForQuotationService: RequestForQuotationService,
    private getFileIconService: GetFileIconUtilityService
  ) {}
  @Output() closeModalEvent = new EventEmitter<boolean>(); // EventEmitter to notify parent
  @Output() technicalSubmissionDataEmitter: EventEmitter<any> =
    new EventEmitter<any>();

  @Input() rfpResponseData: any;
  @Input() tendererResponseData: any;

  form: FormGroup = new FormGroup({
    technical_proposal_control: new FormControl('', Validators.required),
    client_name_control1: new FormControl(''),
    location_control1: new FormControl(''),
    project_description_control1: new FormControl(''),
    client_name_control2: new FormControl(''),
    location_control2: new FormControl(''),
    project_description_control2: new FormControl(''),
    client_name_control3: new FormControl(''),
    location_control3: new FormControl(''),
    project_description_control3: new FormControl(''),
    project_programme_control: new FormControl(''),
    health_safety_control: new FormControl(''),
    environmental_sustainability_control: new FormControl(0),
    environmental_sustainability_description: new FormControl(''),
    technical_deviations_control: new FormControl(0),
    technical_deviations_description: new FormControl(''),
    cv_of_key_personal_file_control: new FormArray([]),
  });

  closeModal = true;

  oldCvsOfKeyPersonnelFileControl = [];
  deletedCvsOfKeyPersonnelFileControl = [];

  ngOnInit(): void {
    this.ittId = this.requestForQuotationService.getRFQId();
    this.requestForQuotationService.isEdit$.subscribe((state) => {
      this.isEdit = state;
    });

    if (this.tendererResponseData) {
      this.mapRFPExistingData();
    }
  }

  get cv_of_key_personal_file_control(): FormArray {
    return this.form.get('cv_of_key_personal_file_control') as FormArray;
  }

  onFileUpload(event: any, currentControl: string): void {
    const files = event.target.files;
    console.log('The files are:', files);
    let control: any;

    if (files && files.length > 0) {
      if (currentControl === 'cv_of_key_personal_file_control') {
        control = this.form.get('cv_of_key_personal_file_control') as FormArray;
      }
      Array.from(files).forEach((file: any) => {
        control.push(new FormControl(file));
      });
    }
  }

  // Remove file
  removeFile(index: number, controlName: string): void {
    const control = this.form.get(controlName) as FormArray;
    control.removeAt(index); // Remove file at index
    console.log('File removed at index:', index);
  }

  // Remove old file
  removeOldFile(index: number, id: number, controlName: string): void {
    switch (controlName) {
      case 'cv_of_key_personal_file_control':
        this.deletedCvOfKeyPersonalFiles.push(id);
        this.oldCvOfKeyPersonalFiles.splice(index, 1);
        break;
      default:
        console.warn(`Unknown control name: ${controlName}`);
        break;
    }

    // Optional: Update form control validity if necessary
    this.form.get(controlName)?.updateValueAndValidity();
  }

  isImageFile(file: any) {
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
    let fileExtension: any;

    if (this.isEdit && !file?.name) {
      fileExtension = file?.split('.').pop()?.toLowerCase();
    } else if (this.isEdit && file?.name) {
      fileExtension = file?.name?.split('.').pop()?.toLowerCase();
    } else {
      fileExtension = file?.name?.split('.').pop()?.toLowerCase();
    }
    return imageExtensions.includes(fileExtension || '');
  }

  downloadDocument() {
    console.log('The download the document ');
  }

  moveToPreviousStep() {
    this.RfqSectionDialogsComponent.previousStep();
  }

  setTechnicalProposal(content: string) {
    this.form.controls['technical_proposal_control'].setValue(content);
  }
  setProjectProgramme(content: string) {
    this.form.controls['project_programme_control'].setValue(content);
  }
  setHealthSafety(content: string) {
    this.form.controls['health_safety_control'].setValue(content);
  }

  prepareDataToSubmit(): FormData {
    if (this.form.valid) {
      const formData = new FormData();

      // Add files from cv_of_key_personal_file_control FormArray
      const cvFiles = this.cv_of_key_personal_file_control.controls.map(
        (control) => control.value
      );
      cvFiles.forEach((file: File, index: number) => {
        formData.append(`cvs_of_key_personnels[${index}]`, file);
      });
      formData.append(
        'deletedSitePreparationFiles[]',
        JSON.stringify(this.deletedCvOfKeyPersonalFiles)
      );

      // Prepare experience data
      const experience = {
        client_name_control1: this.form.value.client_name_control1,
        location_control1: this.form.value.location_control1,
        project_description_control1:
          this.form.value.project_description_control1,
        client_name_control2: this.form.value.client_name_control2,
        location_control2: this.form.value.location_control2,
        project_description_control2:
          this.form.value.project_description_control2,
        client_name_control3: this.form.value.client_name_control3,
        location_control3: this.form.value.location_control3,
        project_description_control3:
          this.form.value.project_description_control3,
      };

      // Append other form data fields
      formData.append('relevant_experience', JSON.stringify(experience));
      formData.append(
        'technical_proposal',
        this.form.value.technical_proposal_control
      );
      formData.append(
        'project_programme',
        this.form.value.project_programme_control
      );
      formData.append(
        'health_safety_plan',
        this.form.value.health_safety_control
      );
      formData.append(
        'has_environmental_plan',
        this.form.value.environmental_sustainability_control.toString()
      );
      formData.append(
        'environmental_plan_description',
        this.form.value.environmental_sustainability_description
      );
      formData.append(
        'has_technical_deviations',
        this.form.value.technical_deviations_control.toString()
      );
      formData.append(
        'technical_deviations_description',
        this.form.value.technical_deviations_description
      );

      return formData;
    }

    throw new Error('Form is invalid. Cannot prepare data for submission.');
  }

  moveToNextStep(nextStep: string) {
    this.form.markAllAsTouched();

    if (this.form.invalid) {
      this.toast.warning(
        'Please fill in all required fields.',
        'WARNING',
        4000
      );
      return;
    }
    const dataToSubmit = this.prepareDataToSubmit();
    this.requestForQuotationService
      .addRfqApplicantTechnicalSubmissionDetails(dataToSubmit, this.ittId)
      .subscribe({
        next: (response) => {
          if (!response?.meta?.success) {
            return;
          }

          this.toast.success('Technical Submission Done', 'SUCCESS');
          this.technicalSubmissionDataEmitter.emit(response?.data);

          if (nextStep === 'commercial') {
            this.RfqSectionDialogsComponent.nextStep();
          } else {
            this.RfqSectionDialogsComponent.currentStep = 4;
          }
        },
        error: (error: any) => {
          console.error('Failed to submit:', error);
          this.toast.danger(error.error.message, 'DANGER', 4000);
        },
      });
  }
  handleBack() {
    this.RfqSectionDialogsComponent.previousStep();
  }

  mapRFPExistingData() {
    if (!this.tendererResponseData) {
      console.warn('Tenderer Response Data is undefined');
      return;
    }

    this.form.patchValue({
      client_name_control1:
        this.tendererResponseData?.relevantExperience?.client_name_control1 ??
        '',
      location_control1:
        this.tendererResponseData?.relevantExperience?.location_control1 ?? '',
      project_description_control1:
        this.tendererResponseData?.relevantExperience
          ?.project_description_control1 ?? '',
      client_name_control2:
        this.tendererResponseData?.relevantExperience?.client_name_control2 ??
        '',
      location_control2:
        this.tendererResponseData?.relevantExperience?.location_control2 ?? '',
      project_description_control2:
        this.tendererResponseData?.relevantExperience
          ?.project_description_control2 ?? '',
      client_name_control3:
        this.tendererResponseData?.relevantExperience?.client_name_control3 ??
        '',
      location_control3:
        this.tendererResponseData?.relevantExperience?.location_control3 ?? '',
      project_description_control3:
        this.tendererResponseData?.relevantExperience
          ?.project_description_control3 ?? '',

      technical_proposal_control:
        this.tendererResponseData?.technicalProposal ?? '',
      project_programme_control:
        this.tendererResponseData?.projectProgramme ?? '',
      health_safety_control: this.tendererResponseData?.healthSafetyPlan ?? '',
      environmental_sustainability_control:
        Number(this.tendererResponseData?.hasEnvironmentalPlan) || 0,
      environmental_sustainability_description:
        this.tendererResponseData?.environmentalPlanDescription ?? '',
      technical_deviations_control:
        Number(this.tendererResponseData?.hasTechnicalDeviations) || 0,
      technical_deviations_description:
        this.tendererResponseData?.technicalDeviationsDescription ?? '',
    });

    this.oldCvOfKeyPersonalFiles =
      this.rfpResponseData?.cvs_of_key_personnels_attachments ?? [];
  }
  getFileIcon(file: {
    file: File;
    preview: string;
    id?: number;
    name?: string;
  }): string {
    return this.getFileIconService.getFileIcon(file);
  }
}
